import React, { useState, useEffect } from 'react';
import { Card, Typography, Button, CardContent, Box } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import './ResponsePreview.css';
import { useParams, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import GlobalVariable from "../../services/Global";
import axios from 'axios';

const baseApiUrl = GlobalVariable.BASE_API_URL;

const Response = () => {
  const navigate = useNavigate();
  const { id, mode } = useParams();
  const [solution, setSolution] = useState('');
  const [docxBase64, setDocxBase64] = useState('');
  const [loading, setLoading] = useState(true);
  const [showDownload, setShowDownload] = useState(false);
  const location = useLocation();
  const [progress, setProgress] = useState(0);

  const rfpIssuer = location.state?.rfpIssuer || sessionStorage.getItem('rfpIssuer');
 const fileName = location.state?.fileName || sessionStorage.getItem('fileName');

 
  //   try {
  //     setLoading(true);
  //     const url =
  //       mode === 'version'
  //         ? `${baseApiUrl}/generate-solution-for-saved-versions?rfpid=${id}`
  //         : `${baseApiUrl}/generate-solution?rfpid=${id}`;

  //     const response = await axios.get(url);
  //     setSolution(response.data.solution);
  //     setDocxBase64(response.data.docx_base64);
  //     setLoading(false);
  //     setShowDownload(true);
  //   } catch (error) {
  //     console.error("Error fetching response:", error);
  //     setLoading(false);
  //   }
  // };
  const fetchResponse = async () => {
    let progressTimer;
  
    try {
      setLoading(true);
      setProgress(0);
      setShowDownload(false);
      progressTimer = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressTimer);
            return 90;
          }
          return prev + 1;
        });
      }, 30);
  
      const url =
        mode === 'version'
          ? `${baseApiUrl}/generate-solution-for-saved-versions?rfpid=${id}`
          : `${baseApiUrl}/generate-solution?rfpid=${id}`;
  
      const response = await axios.get(url);
  
      clearInterval(progressTimer); 
      setProgress(100); 
      setSolution(response.data.solution);
      setDocxBase64(response.data.docx_base64);
      setShowDownload(true);
    } catch (error) {
      console.error("Error fetching response:", error);
    } finally {
      clearInterval(progressTimer);
      setTimeout(() => setLoading(false), 500);
    }
  };
  useEffect(() => {
    fetchResponse();
  }, [id]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowDownload(true);
      } else {
        setShowDownload(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <Card className="responsive-doc-card">
        <CardContent>
          <Row className="mb-2 align-items-center">
            <Col xs={12} sm={6}>
              <Typography className="fontstylee MicroSoftRFPDetails_heading">
                {mode === 'version' ? 'Saved Response Preview' : 'Format Response Preview'} for {rfpIssuer||fileName}
              </Typography>

            </Col>
            <Col xs={12} sm={6} className="d-flex justify-content-end">
              <Button
                aria-label="Go back"
                className="back-button"
                variant="outlined"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
          </Row>

          {loading ? (
        //   <Box position="relative" display="inline-flex">
        //   <CircularProgress variant="determinate" value={progress} />
        //   <Box
        //     sx={{
        //       top: 0,
        //       left: 0,
        //       bottom: 0,
        //       right: 0,
        //       position: 'absolute',
        //       display: 'flex',
        //       alignItems: 'center',
        //       justifyContent: 'center',
        //     }}
        //   >
        //     <Typography variant="caption" component="div" color="text.secondary">
        //       {`${Math.round(progress)}%`}
        //     </Typography>
        //   </Box>
        // </Box>
        <Box
        sx={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          textAlign: 'center',
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress variant="determinate" value={progress} className='text-primary' />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="caption" component="div" color="text.secondary">
              {`${Math.round(progress)}%`}
            </Typography>
          </Box>
        </Box>
      </Box>
      
          ) : (
            <div>
              <Row>
                <Col xs={12} className="mb-3">
                  <div className="solution-container" aria-label="Solution text">
                    <pre>{solution}</pre>
                  </div>
                </Col>
              </Row>

              <Row>
                <div className="d-flex justify-content-end">
                  {showDownload && (
                    <Button
                      variant="contained"
                      className="bg-primary text-capitalize rounded-3"
                      aria-label="Download solution document"
                      style={{
                        position: 'fixed',
                        bottom: '15px',
                        right: '30px',
                        zIndex: 1000,
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        marginBottom: '10px',
                      }}
                      onClick={() => {
                        if (!docxBase64) return;

                        const byteCharacters = atob(docxBase64);
                        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        });

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);

                        const safeFileName = (rfpIssuer || 'response')
                          .replace(/[^a-z0-9]/gi, '_')
                          .toLowerCase();

                        link.download = `${safeFileName}.docx`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}

                    >
                      Download
                    </Button>
                  )}
                </div>
              </Row>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Response;
